import { render, staticRenderFns } from "./customer-row.vue?vue&type=template&id=bf578560&scoped=true"
import script from "./customer-row.vue?vue&type=script&setup=true&lang=js"
export * from "./customer-row.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf578560",
  null
  
)

export default component.exports